<template>
  <div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.county")
        }}</label>
        <DxSelectBox
          v-model="localData.county"
          :data-source="counties"
          display-expr="name"
          value-expr="id"
          :search-enabled="true"
          placeholder=""
        />
      </div>
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.location")
        }}</label>
        <DxSelectBox
          v-model="localData.locality_id"
          :data-source="localities"
          display-expr="name"
          value-expr="id"
          :search-enabled="true"
          placeholder=""
        >
          <DxScrolling mode="virtual" />
        </DxSelectBox>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.street_and_number")
        }}</label>
        <input
          v-model="localData.street_and_number"
          class="form-control"
          placeholder=""
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("common.phone")
        }}</label>
        <input v-model="localData.phone" class="form-control" placeholder="" />
      </div>
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.fax")
        }}</label>
        <input v-model="localData.fax" class="form-control" placeholder="" />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("common.e_mail")
        }}</label>
        <input
          v-model="localData.email"
          type="email"
          class="form-control"
          :class="{ 'field-error': $v.localData.email.$error }"
          placeholder=""
        />
        <div v-if="$v.localData.email.$error" class="invalid-feedback">
          <span v-if="$v.localData.email">
            {{ $t("validation.invalid_email") }}
          </span>
        </div>
      </div>
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.web")
        }}</label>
        <input
          v-model="localData.web"
          type="url"
          class="form-control"
          placeholder=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { email } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import { DxSelectBox } from "devextreme-vue/select-box";
import { DxScrolling } from "devextreme-vue/data-grid";

export default {
  name: "PartnerAddress",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    DxSelectBox,
    DxScrolling,
  },
  data() {
    return {
      localData: { ...this.data }, // Create a local copy of data
      counties: [],
      localities: [],
    };
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    ...mapActions({
      getCounties: "address/getCounties",
      getLocalities: "address/getLocalities",
    }),
    loadLocalitiesForCounty(county_id, locality_id) {
      const county = this.counties.find((county) => county.id == county_id);
      if (!county) {
        this.localities = []; // Clear localities if no county is found
        return;
      }

      this.getLocalities({
        jud_cod: county?.code,
        limit: 10000,
      }).then((response) => {
        this.localities = response
          //.filter((item) => item.locality_type_id != 8)
          .map((item) => ({
            id: item.id,
            name: item.name,
          }));
        // Reset locality selection when counties change
        this.localData.locality_id = locality_id;
      });
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      return true;
    },
     updateData(newData) {
      if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        console.log("updateData step 4 ", newData);
        this.localData = { ...newData }; // Update localData with new data
      }
    },
  },
  mounted() {
    this.getCounties().then((response) => {
      this.counties = response.map((item) => {
        return {
          id: item.id,
          name: item.name,
          code: item.code,
        };
      });

      if (this.localData?.locality?.id) {
        this.localData.county = parseInt(this.localData.locality.county_id);
      }
    });
  },
  watch: {
    "localData.county": {
      immediate: true,
      deep: true,
      handler(newCountyId, oldCountyId) {
        if (newCountyId && newCountyId !== oldCountyId) {
          const locality_id =
            oldCountyId == null ? this.localData?.locality?.id : null;
          this.loadLocalitiesForCounty(newCountyId, locality_id);
        } else if (!newCountyId) {
          this.localities = []; // Clear localities if no county is selected
          this.localData.locality_id = null; // Reset locality selection
        }
      },
    },
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("update-partner-data", newData, 4); // Emit updated data to parent
      },
    },
  },
  validations() {
    return {
      localData: {
        email: {
          email, // Validate only if email is not empty
        },
      },
    };
  },
};
</script>

<style scoped>
.invalid-feedback {
  display: block;
  color: #dc3545;
}
</style>
